module.exports = __webpack_public_path__ + "static/media/VIP_3.2c614cf4.jpg";